import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import CardSeplag from "../../../../components/CardSeplag";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";
import Rotulo from "../../../../components/RotuloSeplag";
import AvaliacaoAcaoRagExecucao from "./AvaliacaoAcaoRagExecucao";
import AvaliacaoAcaoRagMelhoria from "./melhoria";
import AvaliacaoAcaoRagMetaFisica from "./metaFisica";
import AvaliacaoAcaoRagObjetivo from "./objetivo";

import { Card } from "primereact/card";
import imagem01 from "../../../../assets/img/ods/SDG-1.svg";
import imagem10 from "../../../../assets/img/ods/SDG-10.svg";
import imagem11 from "../../../../assets/img/ods/SDG-11.svg";
import imagem12 from "../../../../assets/img/ods/SDG-12.svg";
import imagem13 from "../../../../assets/img/ods/SDG-13.svg";
import imagem14 from "../../../../assets/img/ods/SDG-14.svg";
import imagem15 from "../../../../assets/img/ods/SDG-15.svg";
import imagem16 from "../../../../assets/img/ods/SDG-16.svg";
import imagem17 from "../../../../assets/img/ods/SDG-17.svg";
import imagem02 from "../../../../assets/img/ods/SDG-2.svg";
import imagem03 from "../../../../assets/img/ods/SDG-3.svg";
import imagem04 from "../../../../assets/img/ods/SDG-4.svg";
import imagem05 from "../../../../assets/img/ods/SDG-5.svg";
import imagem06 from "../../../../assets/img/ods/SDG-6.svg";
import imagem07 from "../../../../assets/img/ods/SDG-7.svg";
import imagem08 from "../../../../assets/img/ods/SDG-8.svg";
import imagem09 from "../../../../assets/img/ods/SDG-9.svg";
import {
  buscarItemAcao,
  buscarOdsFiplan,
  buscarPercentualAcao,
  FormIdentificacaoAcao as initForm,
} from "../../../../service/Rag/AvaliacaoPrograma";
import AnaliseProgramaAcaoSeplag from "./analiseAcaoSeplag/AnaliseAcaoSeplag";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Image } from "primereact/image";
import AvaliacaoAcaoRagIndicador from "./component/indicadorAcao";

const linhaGrid = {
  produtopublico: "",
  pos01: 0,
  pos02: 0,
  pos03: 0,
  pos04: 0,
  pos05: 0,
  pos06: 0,
  pos07: 0,
  pos08: 0,
  pos09: 0,
  pos10: 0,
  pos11: 0,
  pos12: 0,
};

const AvaliacaoAcaoRag = () => {
  const location = useLocation();

  const [form, setForm] = useState(initForm);
  const [dadosItemAcao, setDadosItemAcao] = useState(initForm);
  const [parametroExercicio, setParametroExercicio] = useState(location.state.parametroExercicio);

  const [camposQuestionarioMetaFisica, setCamposQuestionarioMetaFisica] = useState();
  const [camposQuestionarioObjetivo, setCamposQuestionarioObjetivo] = useState();
  const [camposQuestionarioExecOrcFin, setCamposQuestionarioExecOrcFin] = useState();
  const [camposQuestionarioAnalisePpdCofd, setCamposQuestionarioAnalisePpdCofd] = useState();
  const [camposQuestionarioEficiencia, setCamposQuestionarioEficiencia] = useState();
  const [camposQuestionarioDisponibilidade, setCamposQuestionarioDisponibilidade] = useState();
  const [camposQuestionarioMelhoria, setCamposQuestionarioMelhoria] = useState();
  const [perfilAcesso, setPerfilAcesso] = useState(false);
  const userPerfil = useSelector((state) => state.userReducer.user.contaAcesso.authorities);
  const [listaOds, setListaOds] = useState();
  const [listaPublicoAlvoTransversal, setPublicoAlvoTransversal] = useState();
  const [listaProdutoAcao, setProdutoAcao] = useState();
  const [listaPublicoMarcado, setPublicoMarcado] = useState();
  const [listaQuestionario, setQuestionario] = useState([]);

  const [percent, setPercent] = useState(0);
  const [abaTelaConfirmada, setAbaTelaConfirmada] = useState(false);

  //const images = require.context(`../../../../assets/img/ods`, true);
  //const imageList = images.keys().map(image => images(image));

  let history = useHistory();

  useEffect(() => {
    permission();
    setForm(location.state.data);
    buscarItemAcao(location.state.data.idView).then((res) => {
      setDadosItemAcao(res.data.dadosItemRag);
      montarQuestionario(res.data.questionarioRag);
      setQuestionario(res.data.questionarioRag);
      setPublicoAlvoTransversal(res.data.dadosItemRag.ptaFiplan.ptaPublicoAlvoAcao);
      setProdutoAcao(res.data.dadosItemRag.produtoAcao);

      //tratamento para coletar o percentual das perguntas preenchidas pelo total que perguntas, na entrada da tela---
      //calculo recuperado atraves do banco de dados
      buscarPercentualAcao(
        res.data.dadosItemRag.ptaFiplan.exercicio.idenExercicio,
        "ACAO",
        res.data.dadosItemRag.idenPtaMonitora
      ).then((res) => {
        //console.log("ENTRADA: ",res.data);
        setPercent(res.data);
      });
      //----------------

      buscarOdsFiplan(location.state.data.idenPtaFiplan).then((res) => {
        const sortedList = res.data.sort((a, b) => a.codgOds - b.codgOds);
        setListaOds(sortedList);
      });
    });
  }, []);

  useEffect(() => {
    //Atraves da confirmcao da aba, faz o tratamento para buscar o valor de preenchimento dos itens do questionario
    if (abaTelaConfirmada) {
      dadosItemAcao.idenPtaMonitora &&
        buscarPercentualAcao(
          dadosItemAcao.ptaFiplan.exercicio.idenExercicio,
          "ACAO",
          dadosItemAcao.idenPtaMonitora
        ).then((res) => {
          //console.log("PelaTelaConfirmada",res.data);
          setPercent(res.data);
          setAbaTelaConfirmada(false);
        });
    }
  }, [abaTelaConfirmada]);

  useEffect(() => {
    //Tratamento para percorrer a lista de Produtos e atribuir os valores da Descricao e seus valores por coluna
    let listaAux = [];
    listaProdutoAcao &&
      listaProdutoAcao.map((produtoAcao) => {
        let varAux = { ...linhaGrid };
        varAux.produtopublico = produtoAcao.ptaFiplan.descricaoFiplan;
        //  console.log(varAux.produtopublico)
        //  console.log(produtoAcao.ptaFiplan)
        produtoAcao.ptaFiplan.ptaPublicoAlvo.map((item) => {
          //console.log(item)
          // if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 5 &&
          //   varAux.produtopublico === "840 - Encontro anual dos CFC's realizado"
          // ){
          //   //Para testar a pessoa idosa
          //   console.log(varAux.produtopublico)
          //   console.log("TESTE01Item",item)
          // }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 1 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos01 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 2 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos02 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 3 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos03 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 4 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos04 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 5 && item.statPtaFiplanPublicoAlvo === 1) {
              varAux.pos05 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 6 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos06 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 7 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos07 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 8 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos08 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 9 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos09 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 10 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos10 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 11 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos11 = 1;
          }
          if (item.publicoAlvoTransversal.codgPublicoAlvoTransversal === 12 && item.statPtaFiplanPublicoAlvo === 1) {
            varAux.pos12 = 1;
          }
        });
        listaAux.push(varAux);
      });
    setPublicoMarcado(listaAux);
  }, [listaProdutoAcao]);

  const permission = () => {
    for (let i = 0; i < userPerfil.length; i++) {
      if (
        userPerfil[i].nomeRole === "MONRL_ADMIN_CENTRAL" ||
        userPerfil[i].nomeRole === "MONRL_ANALISTA" ||
        userPerfil[i].nomeRole === "MONRL_LANCAMENTO" ||
        userPerfil[i].nomeRole === "MONRL_ADMIN_SETORIAL"
      )
        setPerfilAcesso(true);
    }
  };

  function montarQuestionario(questionario) {
    let questMetaFisica = mapQuestionario(
      questionario.filter((questP) => questP.descCategoriaPergunta === "Meta Física")
    );
    setCamposQuestionarioMetaFisica(JSON.stringify(questMetaFisica));

    let questObjetivo = mapQuestionario(questionario.filter((questP) => questP.descCategoriaPergunta === "Objetivo"));
    setCamposQuestionarioObjetivo(JSON.stringify(questObjetivo));

    let questExecOrcFin = mapQuestionario(
      questionario.filter((questP) => questP.descCategoriaPergunta === "Execução Orçamentária e Financeira")
    );
    setCamposQuestionarioExecOrcFin(JSON.stringify(questExecOrcFin));

    let questAnalisePpdCofd = mapQuestionario(
      questionario.filter((questP) => questP.descSubCategoriaPergunta === "Análise do PPD e COFD")
    );
    setCamposQuestionarioAnalisePpdCofd(JSON.stringify(questAnalisePpdCofd));

    let questEficiencia = mapQuestionario(
      questionario.filter((questP) => questP.descSubCategoriaPergunta === "Eficiência")
    );
    setCamposQuestionarioEficiencia(JSON.stringify(questEficiencia));

    let questDisponibilidade = mapQuestionario(
      questionario.filter((questP) => questP.descSubCategoriaPergunta === "Disponibilidade Financeira")
    );
    setCamposQuestionarioDisponibilidade(JSON.stringify(questDisponibilidade));

    let questMelhoria = mapQuestionario(
      questionario.filter((questP) => questP.descCategoriaPergunta == "Sugestão de Melhoria")
    );
    setCamposQuestionarioMelhoria(JSON.stringify(questMelhoria));
  }

  function mapQuestionario(qmap) {
    let retorno = qmap
      .map((questao) => {
        return {
          ...questao,
          id: questao.rowId,
          label: `${questao.numrPergunta} - ${questao.descPergunta}`,
          data: questao.valrRespostaItemQuest,
          type: questao.siglTipoPergunta,
          idenArquivo: questao.idenArquivo,
          options: questao.opcoes.split("/").map((opcao) => {
            return {
              code: opcao.trim(),
              name: opcao.trim(),
            };
          }),
        };
      })
      .sort((a, b) => {
        return a.numrOrdemPergunta - b.numrOrdemPergunta;
      });

    return retorno;
  }

  function formatarPercentual(perc) {
    //Recupera o numero inteiro do percentual e concatena o sinal de %
    const parteInteira = Math.floor(perc);
    return `${parteInteira}%`;
  }

  function condicao(campo, campos) {
    if (campo?.infoDependencia) {
      let arrayDependencia = campo.infoDependencia.split("@");
      let idenQuestionarioPergunta = arrayDependencia[0];
      if (arrayDependencia[1]) {
        let campoArrayValues = arrayDependencia[1].split("||");
        let perguntaDependente = campos.find((camp) => camp.idenQuestionarioPergunta == idenQuestionarioPergunta);
        let ativarPerguntaDependente = false;
        campoArrayValues.forEach((itemValue) => {
          if (itemValue === perguntaDependente.data) {
            ativarPerguntaDependente = true;
          }
        });
        return ativarPerguntaDependente;
      } else {
        return true;
      }
    }
    return true;
  }

  const tabIdentificacaoTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".3em" }}
        >
          <i className="pi pi-tags" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabIndicadorTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".3em" }}
        >
          <i className="pi pi-chart-bar" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabMetaFisicaTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".3em" }}
        >
          <i className="pi pi-chart-line" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const taObjetivoTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".3em" }}
        >
          <i className="pi pi-check-square" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabExecucaoTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".3em" }}
        >
          <i className="pi pi-cog" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabMelhoriaTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".3em" }}
        >
          <i className="pi pi-comments" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tabAnaliseTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button
          type="button"
          onClick={options.onClick}
          className={classSelected + " Raised"}
          style={{ marginLeft: ".3em" }}
        >
          <i className="pi pi-align-center" style={{ margin: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  function titleCard() {
    let titulo =
      form && form.unidadeOrcamentaria
        ? "UO: " +
          form.unidadeOrcamentaria.descricaoFiplan +
          " - PROGRAMA: " +
          form.programa.descricaoFiplan.toUpperCase() +
          " - AÇÃO: " +
          form.codFiplanItem +
          " - " +
          form.descricaoItem
        : "";
    return <span>{titulo}</span>;
  }

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  const imagesAux = {
    "SDG-1.svg": imagem01,
    "SDG-2.svg": imagem02,
    "SDG-3.svg": imagem03,
    "SDG-4.svg": imagem04,
    "SDG-5.svg": imagem05,
    "SDG-6.svg": imagem06,
    "SDG-7.svg": imagem07,
    "SDG-8.svg": imagem08,
    "SDG-9.svg": imagem09,
    "SDG-10.svg": imagem10,
    "SDG-11.svg": imagem11,
    "SDG-12.svg": imagem12,
    "SDG-13.svg": imagem13,
    "SDG-14.svg": imagem14,
    "SDG-15.svg": imagem15,
    "SDG-16.svg": imagem16,
    "SDG-17.svg": imagem17,
  };

  const getImageSrc = (nomeImagem) => imagesAux[nomeImagem];

  //sinaliza o icone para cada item com valor um
  const renderIcon = (rowData) => {
    //console.log(rowData)
    return rowData === 1 ? <i className="pi pi-times-circle" style={{ color: "green" }} /> : " ";
  };

  //Controle para identificar se o ano eh igual ou superior a 2024
  const exercicio2024 = dadosItemAcao.ptaFiplan.codgExercicio >= 2024 ? true : false;

  const selectOptionValue = [
    { name: "Sim", value: "S" },
    { name: "Não", value: "N" },
  ];

  return (
    <div className="card" style={{ overflow: "hidden" }}>
      <Card title={titleCard()} style={{ height: "auto" }}>
        <TabView className="sm-invisibleWeb">
          <TabPanel header="Identificação" className="menu-div col" headerTemplate={tabIdentificacaoTemplate}>
            <CardSeplagScrol title="Identificação">
              {exercicio2024 && (
                <div className="div-flex justify-content-end " style={{ paddingRight: "20px", display: "flex" }}>
                  <div className="grid">
                    <div
                      className="col text-center border-round-sm bg-primary font-bold"
                      style={{ padding: "0.5rem 1rem !important", alignContent: "center", height: "fit-content" }}
                    >
                      <p style={{ maxWidth: "fit-content" }}>
                        % DE PREENCHIMENTO <br /> DA AÇÃO
                      </p>
                    </div>
                    <div
                      className="col text-center p-3 border-round-sm bg-primary font-bold"
                      style={{
                        padding: "0.5rem 1rem !important",
                        alignContent: "center",
                        height: "100%",
                        marginLeft: "5px",
                      }}
                    >
                      {formatarPercentual(percent)}
                    </div>
                  </div>
                </div>
              )}

              <div className="div-flex" style={{display:"flex"}}>
                <CardSeplag propWidth="100%">
                  <div style={{ justifyContent: "space-between", display:"flex" }} className="div-flex">
                    <div style={{ width: "80%" }}>
                      <Rotulo nome="Descrição:" className="p-col-12">
                        <label>
                          {dadosItemAcao && dadosItemAcao?.ptaFiplan.codgElemento != null
                            ? dadosItemAcao.ptaFiplan.codgElemento + " - " + dadosItemAcao.ptaFiplan.descElemento
                            : ""}
                        </label>
                      </Rotulo>
                    </div>
                    {exercicio2024 && (
                      <div
                        style={{
                          width: "20%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          textAlign: "end",
                        }}
                      >
                        <Rotulo
                          nome={
                            <>
                              Ação Prioritária
                              <br />
                              conf. PPA/LDO
                            </>
                          }
                          className="p-col-12"
                        ></Rotulo>

                        <div
                          className="text-center p-3 border-round-sm bg-primary font-bold"
                          style={{ marginLeft: "5px" }}
                        >
                          {/* {listaProdutoAcao && (listaProdutoAcao[0].ptaFiplan.flagPrioritario === "S" ? "Sim" : "Não")} */}
                          {dadosItemAcao.flagPrioritario && (dadosItemAcao.flagPrioritario === "S" ? "Sim" : "Não")}
                        </div>
                      </div>
                    )}
                  </div>
                  <hr />

                  <div style={{ width: "100%" }}>
                    <Rotulo nome="Objetivo Específico da Ação:" className="p-col-12">
                      <label>
                        {dadosItemAcao &&
                          (dadosItemAcao.ptaFiplan.ptaFiplanDetalhe
                            ? dadosItemAcao.ptaFiplan.ptaFiplanDetalhe.descObjetivo
                            : "")}
                      </label>
                    </Rotulo>
                  </div>
                  <hr />
                  <div style={{ justifyContent: "space-between", display:"flex" }} className="div-flex">
                    <div style={{ width: "75%" }}>
                      <Rotulo nome="Responsável:" className="p-col-12" width="30%">
                        <label>
                          {dadosItemAcao && (dadosItemAcao.pessoaResp ? dadosItemAcao.pessoaResp.nomePessoa : "")}
                        </label>
                      </Rotulo>
                    </div>

                    {exercicio2024 && (
                      <div style={{ width: "25%" }}>
                        <Rotulo nome="ODS vinculada:" className="p-col-12" width="70%">
                          <div className="div-flex">
                            {listaOds &&
                              (listaOds ? (
                                listaOds.map((ods) => (
                                  <div key={ods.codgOds}>
                                    <Image
                                      src={getImageSrc(ods.nomeImagem)}
                                      alt={ods.nomeImagem}
                                      width="60"
                                      height="60"
                                    />
                                  </div>
                                ))
                              ) : (
                                <p> Sem dados de ODS.</p>
                              ))}
                          </div>
                        </Rotulo>
                      </div>
                    )}
                  </div>
                  <hr />
                </CardSeplag>
              </div>

              {exercicio2024 && (
                <CardSeplag>
                  <Rotulo nome="Produto x Público Alvo Transversal:">
                    <label>
                      <DataTable value={listaPublicoMarcado} showGridlines tableStyle={{ minWidth: "50rem" }}>
                        <Column
                          field="produtopublico"
                          header="Produto x Público-Alvo Transvesal"
                          style={{ width: "20%" }}
                        ></Column>
                        <Column
                          field="pos02"
                          header="Adolescentes"
                          body={(rowData) => renderIcon(rowData.pos02)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos09"
                          header="Comunidades Tradicionais e Quilombolas"
                          body={(rowData) => renderIcon(rowData.pos09)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos01"
                          header="Crianças"
                          body={(rowData) => renderIcon(rowData.pos01)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos03"
                          header="Juventude"
                          body={(rowData) => renderIcon(rowData.pos03)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos04"
                          header="Mulheres"
                          body={(rowData) => renderIcon(rowData.pos04)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos10"
                          header="Negros"
                          body={(rowData) => renderIcon(rowData.pos10)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos06"
                          header="Pessoas com deficiências"
                          body={(rowData) => renderIcon(rowData.pos06)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos05"
                          header="Pessoa idosa"
                          body={(rowData) => renderIcon(rowData.pos05)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos07"
                          header="População em situação de rua"
                          body={(rowData) => renderIcon(rowData.pos07)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos11"
                          header="População LGBTQIAPN+"
                          body={(rowData) => renderIcon(rowData.pos11)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos08"
                          header="Povos Indígenas"
                          body={(rowData) => renderIcon(rowData.pos08)}
                          style={{ textAlign: "center" }}
                        ></Column>
                        <Column
                          field="pos12"
                          header="Não se aplica"
                          body={(rowData) => renderIcon(rowData.pos12)}
                          style={{ textAlign: "center" }}
                        ></Column>
                      </DataTable>
                    </label>
                  </Rotulo>
                </CardSeplag>
              )}

              <div className="p-fluid grid">
                <div className="field col-12 md:col-8 ">&nbsp;</div>
                <div className="field col-12 md:col-2 "></div>
                <div className="field col-12 md:col-2 ">
                  <br></br>
                  <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
                </div>
              </div>
            </CardSeplagScrol>
          </TabPanel>
          {exercicio2024 && (
            <TabPanel header="Indicadores" className="menu-div col" headerTemplate={tabIndicadorTemplate}>
              <AvaliacaoAcaoRagIndicador
                condicao={condicao}
                dadosItemPrograma={null}
                podeAvaliarIndicador={location.state.podeAvaliarAcao}
                idenPessoaResp={null}
                dadosItemAcao={dadosItemAcao}
              ></AvaliacaoAcaoRagIndicador>
            </TabPanel>
          )}
          <TabPanel header="Meta Física" className="menu-div col" headerTemplate={tabMetaFisicaTemplate}>
            <AvaliacaoAcaoRagMetaFisica
              dadosItemAcao={dadosItemAcao}
              setDadosItemAcao={setDadosItemAcao}
              questionario={camposQuestionarioMetaFisica}
              setCamposQuestionarioMetaFisica={setCamposQuestionarioMetaFisica}
              condicao={condicao}
              podeAvaliarAcao={location.state.podeAvaliarAcao}
              aba={setAbaTelaConfirmada}
            ></AvaliacaoAcaoRagMetaFisica>
          </TabPanel>
          <TabPanel
            header={exercicio2024 ? "Objetivo da Ação" : "Objetivo"}
            className="menu-div col"
            headerTemplate={taObjetivoTemplate}
          >
            <AvaliacaoAcaoRagObjetivo
              dadosItemAcao={dadosItemAcao}
              questionario={camposQuestionarioObjetivo}
              setCamposQuestionarioObjetivo={setCamposQuestionarioObjetivo}
              condicao={condicao}
              podeAvaliarAcao={location.state.podeAvaliarAcao}
              aba={setAbaTelaConfirmada}
            ></AvaliacaoAcaoRagObjetivo>
          </TabPanel>
          <TabPanel
            header={exercicio2024 ? "Execução Orçamentária" : "Execução"}
            className="menu-div col"
            headerTemplate={tabExecucaoTemplate}
          >
            <AvaliacaoAcaoRagExecucao
              dadosItemAcao={dadosItemAcao}
              questionarioPPDCOFD={camposQuestionarioAnalisePpdCofd}
              setCamposQuestionarioAnalisePpdCofd={setCamposQuestionarioAnalisePpdCofd}
              questionarioDispFinan={camposQuestionarioDisponibilidade}
              setCamposQuestionarioDisponibilidade={setCamposQuestionarioDisponibilidade}
              questionarioEficiencia={camposQuestionarioEficiencia}
              setCamposQuestionarioEficiencia={setCamposQuestionarioEficiencia}
              condicao={condicao}
              podeAvaliarAcao={location.state.podeAvaliarAcao}
              aba={setAbaTelaConfirmada}
            ></AvaliacaoAcaoRagExecucao>
          </TabPanel>
          {
            // esconder aba sugestão para usuários com perfil de órgão de controle
            userPerfil.some((item) => {
              return item.nomeRole !== "MONRL_ACESSO_ORGAO_CONTROLE";
            }) && (
              <TabPanel
                header={exercicio2024 ? "Sugestão de Melhoria" : "Melhoria"}
                className="menu-div col"
                headerTemplate={tabMelhoriaTemplate}
              >
                <AvaliacaoAcaoRagMelhoria
                  dadosItemAcao={dadosItemAcao}
                  questionario={camposQuestionarioMelhoria}
                  setCamposQuestionarioMelhoria={setCamposQuestionarioMelhoria}
                  condicao={condicao}
                  podeAvaliarAcao={location.state.podeAvaliarAcao}
                  aba={setAbaTelaConfirmada}
                ></AvaliacaoAcaoRagMelhoria>
              </TabPanel>
            )
          }
          {true && (
            <TabPanel
              header={exercicio2024 ? "Análise do Órgão Central" : "Análise SEPLAG"}
              className="menu-div col"
              headerTemplate={tabAnaliseTemplate}
            >
              <AnaliseProgramaAcaoSeplag
                dadosItemAcao={dadosItemAcao}
                parametroExercicio={parametroExercicio}
                form={form}
                podeAnalisarAcao={location.state.podeAvaliarAcao}
              />
            </TabPanel>
          )}
        </TabView>
      </Card>
    </div>
  );
};

export default AvaliacaoAcaoRag;
